import { useState } from "react";
import * as Toast from "@radix-ui/react-toast";
import type { LiveBlock } from "../../shared/types";
import { formatFlr } from "../../shared/format";
import { FLARE_EXPLORER_URL } from "../../shared/constants";
import { CloseIcon, ExternalLinkIcon, FlameIcon } from "./Icons";

export function AlertToast({ block }: { block: LiveBlock | null }) {
  const [open, setOpen] = useState(Boolean(block));
  if (!block) return null;
  const explorerUrl = `${FLARE_EXPLORER_URL}/block/${block.blockNumber}`;
  const formattedBlockNumber = new Intl.NumberFormat("en-US").format(BigInt(block.blockNumber));
  return (
    <Toast.Root className={`burn-toast burn-toast--${block.severity}`} open={open} onOpenChange={setOpen} type="background" duration={8_000}>
      <a
        className="burn-toast__link"
        href={explorerUrl}
        target="_blank"
        rel="noreferrer"
        aria-label={`Open block ${block.blockNumber} in Flare Explorer (new tab)`}
      >
        <FlameIcon className="burn-toast__icon" />
        <div className="burn-toast__content">
          <Toast.Title>{block.severity === "exceptional" ? "Exceptional block burn" : "Elevated block burn"}</Toast.Title>
          <Toast.Description>{formatFlr(block.totalBurnWei)} FLR burned</Toast.Description>
          <span className="burn-toast__meta">
            View block {formattedBlockNumber} in Explorer
            <ExternalLinkIcon />
          </span>
        </div>
      </a>
      <Toast.Close className="icon-button" aria-label="Dismiss burn notification"><CloseIcon /></Toast.Close>
    </Toast.Root>
  );
}
